import FolderFormModal from './FolderFormModal';
import DeleteConfirmModal from './DeleteConfirmModal';
import MoveFolderModal from './MoveFolderModal';

const FolderPopups = ({
  popup,
  popupData,
  rawFolders,
  actionLoading,
  onClose,
  onCreateFolder,
  onRenameFolder,
  onDeleteFolder,
  onMoveFolder,
}) => (
  <>
    {popup === 'create_folder' && (
      <FolderFormModal
        type="create"
        initialData={{ parentFolderId: popupData?.parentFolderId ?? null }}
        onSubmit={onCreateFolder}
        onClose={onClose}
        loading={actionLoading}
      />
    )}

    {popup === 'rename_folder' && (
      <FolderFormModal
        type="rename"
        initialData={{
          folderName: popupData?.name || '',
          folderDescription: popupData?.folderDescription || '',
          parentFolderId: popupData?.parentFolderId ?? null,
        }}
        onSubmit={onRenameFolder}
        onClose={onClose}
        loading={actionLoading}
      />
    )}

    {popup === 'delete_folder' && (
      <DeleteConfirmModal
        title="Delete Folder"
        message={`Delete "${popupData?.name ?? 'this folder'}" and all its subfolders? This action cannot be undone.`}
        onConfirm={onDeleteFolder}
        onClose={onClose}
        loading={actionLoading}
      />
    )}

    {popup === 'move_folder' && popupData && (
      <MoveFolderModal
        folder={popupData}
        rawFolders={rawFolders}
        onConfirm={onMoveFolder}
        onClose={onClose}
        loading={actionLoading}
      />
    )}
  </>
);

export default FolderPopups;
